import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/cookies")({
  component: CookiesPage,
  head: () => ({
    meta: [
      { title: "Cookie Policy — CoderLity" },
      { name: "description", content: "How CoderLity uses cookies and similar technologies across our sites and applications." },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/cookies" }],
  }),
});

function CookiesPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Cookie Policy"
      sub="What cookies we set, why, and how you can control them."
      updated="May 1, 2026"
      sections={[
        { heading: "What are cookies", body: "Small text files stored on your device that help websites remember you and how you use them." },
        { heading: "Cookies we use", body: "Strictly necessary (session, security, load balancing), preferences (theme, language), and analytics (anonymous usage trends)." },
        { heading: "Third parties", body: "We may use providers such as Google Analytics, Meta Pixel and payment gateways which set their own cookies under their own policies." },
        { heading: "Managing cookies", body: "You can clear or block cookies in your browser settings. Doing so may impact some features of the site." },
      ]}
    />
  );
}
